module.exports = __webpack_public_path__ + "static/media/arrow-top.66773d33.svg";